<template>
  <box>
    <slot
      v-if="isVehicleIconVisible"
      slot="icon"
      name="icon"
    />
    <div
      :class="{
        'vehicle-approval-wrapper': isVehicleImageVisible,
        'is-column': isVehicleApproveInColumn,
      }"
    >
      <img
        v-show="isImageLoaded"
        class="vehicle-image"
        :src="carImageUrl"
        alt="Vehicle Image"
        @load="isImageLoaded = true"
      >
      <div
        :class="{ 'vehicle-approval-text': isVehicleImageVisible }"
      >
        <slot />
      </div>
    </div>
  </box>
</template>

<script>
import {
  inject,
  computed,
  ref,
} from '@vue/composition-api';
import { useVuetify } from '@/composables/useVuetify.js';
export default {
  name: 'vehicle-selector-preview',
  setup () {
    // INJECTS
    const config = inject('config');

    // COMPOSABLES
    const vuetify = useVuetify();

    // DATA
    const isImageLoaded = ref(false);

    // COMPUTED
    const isVehicleImageVisible = computed(() => {
      return config.displayImageEnabled && config.carImageUrl?.length;
    });
    const isVehicleImageLarge = computed(() => {
      return config?.carImageSize === 'large';
    });
    const isVehicleIconVisible = computed(() => {
      if (!isVehicleImageVisible.value) return true;

      return vuetify.breakpoint.smAndUp && isVehicleImageLarge.value;
    });
    const isVehicleApproveInColumn = computed(() => {
      return isVehicleImageVisible.value && isVehicleImageLarge.value;
    });

    return {
      // INJECTS
      carImageUrl: config.carImageUrl,

      // DATA
      isImageLoaded,

      // COMPUTED
      isVehicleImageVisible,
      isVehicleIconVisible,
      isVehicleApproveInColumn,
    };
  },
};
</script>

<style lang="scss">
.vehicle-approval-wrapper {
  .vehicle-image {
    max-width: 100%;
    border: 1px solid var(--v-primary-base, $clr-primary);
  }

  .vehicle-approval-text {
    margin-top: 20px;
  }

  @media screen and (min-width: 600px) {
    display: flex;
    align-items: flex-start;

    .vehicle-approval-text {
      margin-top: 0;
      margin-left: 20px;
    }

    &.is-column {
      flex-direction: column-reverse;

      .vehicle-approval-text {
        margin-left: 0;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
